<template>
  <div class="teaching-arrange-setting-configure"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="defaults">
      <div class="header">
        <el-alert title="导入排课时，成绩比例未设置的将采用默认规则设置生成"
                  type="warning"
                  :closable="false"></el-alert>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <AppScrollbar style="height: 100%">
            <div class="configure-main">
              <div class="config-item">
                <div class="label">
                  <TitleGroup title="上课时段说明"
                              :bold="false"></TitleGroup>
                </div>
                <div class="value">
                  <TeachingArrangeSettingPeriod ref="period"
                                                :disabled="!defaultsEnabled"
                                                :periods="getPeriods"></TeachingArrangeSettingPeriod>
                </div>
              </div>
              <div class="config-item">
                <div class="label">
                  <TitleGroup title="设置成绩比例（同一课程类别下，各比例总和需为100%）"
                              :bold="false"></TitleGroup>
                </div>
                <div class="value">
                  <TeachingArrangeSettingScale ref="scale"
                                               :disabled="!defaultsEnabled"
                                               :scales="getScales"></TeachingArrangeSettingScale>
                </div>
              </div>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div v-if="defaultsEnabled"
           class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">保存设置</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>配置信息加载失败</div>
        <el-button type="text"
                   @click="loadDefaults">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import TeachingArrangeSettingPeriod from '../widget/period'
import TeachingArrangeSettingScale from '../widget/scale'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingArrangeSettingConfigure',
  components: {
    AppScrollbar,
    TitleGroup,
    TeachingArrangeSettingPeriod,
    TeachingArrangeSettingScale,
    Hint
  },
  props: {
    defaultsEnabled: Boolean,
    lessonPeriods: Array,
    courseTypes: Array
  },
  data () {
    return {
      loading: false,
      defaults: null,
      committing: false
    }
  },
  computed: {
    getPeriods () {
      const defaults = this.defaults
      if (defaults) {
        let getPeriods = defaults.periods
        if (getPeriods) {
          const lessonPeriods = this.lessonPeriods
          if (lessonPeriods) {
            return lessonPeriods.map(item => {
              let value = getPeriods.find(v => v.type === item.code)
              return this.$extend(item, value)
            })
          }
        }
      }
    },
    getScales () {
      const defaults = this.defaults
      if (defaults) {
        let getScales = defaults.scales
        if (getScales) {
          const courseTypes = this.courseTypes
          if (courseTypes) {
            return courseTypes.map(item => {
              let value = getScales.find(v => v.courseTypeId === item.id)
              return this.$extend(item, value)
            })
          }
        }
      }
    }
  },
  methods: {
    loadDefaults () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/setting/arrange/defaults',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.defaults = response.data['defaults'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      let validates = []
      let period = this.$refs.period
      if (period) {
        validates.push(period.validate())
      }
      let scale = this.$refs.scale
      if (scale) {
        validates.push(scale.validate())
      }
      if (validates.length) {
        Promise.all(validates).then(([periods, scales]) => {
          this.committing = true
          this.$ajax({
            url: '/workspace/manager/teaching/setting/arrange/submitDefaults',
            method: 'post',
            data: this.$qs.stringify({
              settingInfo: JSON.stringify({periods, scales})
            })
          }).then(response => {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          }).finally(() => {
            this.committing = false
          })
        }, err => {
          this.$message.warning(err.message)
        })
      }
    }
  },
  mounted () {
    this.loadDefaults()
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting-configure {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      .el-alert {
        & > .el-alert__content {
          & > .el-alert__title {
            font-size: 12px;
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .configure-main {
          padding: 30px 15px;
          & > .config-item {
            max-width: 100%;
            margin: auto;
            width: 720px;
            & > .value {
              margin-top: 10px;
            }
            & + .config-item {
              margin-top: 30px;
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
